<script>
import render from '../../PageDesigner/utils/render'
const layouts = {
  normalTableItem(h, element, index, parent) {
    let className = 'drawing-item'
    if (this.formConf.unFocusedComponentBorder) className += ' unfocus-bordered'
    return (
      <el-col span={element.span} class={className}>
        <xr-table ref={element.itemRef} configure={element.configure}>
          <render key={element.renderKey} conf={element} onInput={ event => {
            // TODO
          }} />
        </xr-table>
      </el-col>
    )
  },
  colFormItem(h, element, index, parent) {
    let className = 'drawing-item'
    if (this.formConf.unFocusedComponentBorder) className += ' unfocus-bordered'
    return (
      <el-col span={element.span} class={className}>
        <el-form-item label-width={element.labelWidth ? `${element.labelWidth}px` : null}
          label={element.itemLabel} required={element.required}>
          <render key={element.renderKey} conf={element} onInput={ event => {
            this.$set(element, 'defaultValue', event)
            this.$set(this.formConf, element.vModel, event)
          }} />
        </el-form-item>
      </el-col>
    )
  },
  rowFormItem(h, element, index, parent) {
    const className = 'drawing-row-item'
    let child = renderChildren.apply(this, arguments)
    if (element.type === 'flex') {
      child = <el-row type={element.type} justify={element.justify} align={element.align}>
              {child}
            </el-row>
    }
    return (
      <el-col span={element.span}>
        <el-row gutter={element.gutter} class={className}>
          <span class="component-name">{element.componentName}</span>
        </el-row>
      </el-col>
    )
  }
}

function renderChildren(h, element, index, parent) {
  if (!Array.isArray(element.children)) return null
  return element.children.map((el, i) => {
    const layout = layouts[el.layout]
    if (layout) {
      return layout.call(this, h, el, i, element.children)
    }
    return layoutIsNotFound()
  })
}

function layoutIsNotFound() {
  throw new Error(`没有与${this.element.layout}匹配的layout`)
}

export default {
  components: {
    render
  },
  props: [
    'element',
    'index',
    'itemList',
    'formConf'
  ],
  render(h) {
    const layout = layouts[this.element.layout]
    if (layout) {
      return layout.call(this, h, this.element, this.index, this.itemList)
    }
    return layoutIsNotFound()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/template/common/template-item.vue